<template>
  <div class="modal-wrapper">
    <div class="modal-dialog extra-large-modal" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Detalhes da mensalidade
          </h4>
        </div>
        <div v-if="selectedBill" class="modal-body modal-body--scrollable">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Status</th>
                <th v-if="selectedBill.status === 'paid'">
                  Data do pagamento
                </th>
                <th v-if="selectedBill.status === 'ignored'">
                  Motivo do status
                </th>
                <th>Vencimento</th>
                <th>Mês de referência</th>
                <th>Tipo</th>
                <th>Pode ter encargos</th>
                <th>ID externo</th>
                <th>Observações</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ selectedBill.id }}</td>
                <td>{{ selectedBill.translated_status }}</td>
                <td v-if="selectedBill.status === 'paid'">
                  {{ selectedBill.paid_date | formatDate }}
                </td>
                <td v-if="selectedBill.status === 'ignored'">
                  {{ selectedBill.ignored_reason_label }}
                </td>
                <td>{{ selectedBill.due_date | formatDate }}</td>
                <td>{{ selectedBill.bill_month }}/{{ selectedBill.bill_year }}</td>
                <td>{{ selectedBill.translated_bill_type }}</td>
                <td>{{ selectedBill.apply_charges | formatBoolean }}</td>
                <td>{{ selectedBill.external_id }}</td>
                <td class="observations-column">
                  {{ selectedBill.observations }}
                </td>
              </tr>
            </tbody>
          </table>

          <p class="panel__title">
            Composição do valor a ser pago
          </p>

          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Valor cheio</th>
                <th>
                  <div class="discounts-line">
                    <span>Descontos (-)</span>
                    <div class="discounts-button">
                      <dropdown-filter-list
                        text-displayed="Filtro de descontos"
                        :reference-id="`bill-${selectedBill.id}`"
                        :items-filter="discountsFilter"
                        :pre-selected-items="selectedDiscountsFilter"
                        @items-changed="discountsFilterChanged"
                      />
                      <button
                        v-if="selectedBill.can_charge"
                        v-permissions:discount.create
                        title="Adicionar"
                        class="btn btn-primary"
                        @click="openCreateDiscountModal"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </div>
                  </div>
                </th>
                <th>Acréscimos (+)</th>
                <th>Total a ser pago</th>
                <th>Valor pago</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ selectedBill.full_amount | formatCurrency }}</td>
                <td>
                  <div class="discounts-line" v-for="(discount, index) in filtredDiscounts()" :key="index">
                    <div class="discounts-span">
                      <strong>{{ discount.translated_kind }}:</strong>
                      {{ discount.amount | formatCurrency }}
                      <span v-if="!discount.enabled">
                        (desativado em {{ discount.enabled_until | formatDate }})
                      </span>
                      <span v-else-if="discount.expiry_date">
                        (expira em {{ discount.expiry_date | formatDate }})
                      </span>
                    </div>
                    <div class="discounts-button">
                      <button
                        v-if="selectedBill.can_charge && !hasParcelamento"
                        v-permissions:discount.update
                        :title="discount.enabled ? 'Editar' : 'Editar e reativar'"
                        class="btn btn-primary"
                        @click="openEditDiscountModal(discount)"
                      >
                        <i class="fas fa-edit"></i>
                      </button>
                      <button
                        v-if="selectedBill.can_charge && !hasParcelamento"
                        v-permissions:discount.disable
                        :disabled="!discount.enabled"
                        title="Desativar"
                        class="btn btn-danger"
                        @click="openDisableDiscountModal(discount)"
                      >
                        <i class="fas fa-ban"></i>
                      </button>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-for="(addition, index) in selectedBill.additions" :key="index">
                    <strong>{{ addition.kind_label }}:</strong> {{ addition.amount | formatCurrency }}
                  </div>
                  <div v-if="selectedBill.interest !== '0.0'">
                    <strong>Juros:</strong> {{ selectedBill.interest | formatCurrency }}
                  </div>
                  <div v-if="selectedBill.penalty !== '0.0'">
                    <strong>Multa:</strong> {{ selectedBill.penalty | formatCurrency }}
                  </div>
                </td>
                <td class="total-value">
                  {{ selectedBill.amount_with_charges | formatCurrency }}
                </td>
                <td>{{ selectedBill.paid_amount | formatCurrency }}</td>
              </tr>
            </tbody>
          </table>

          <hr class="divider divider--spaced-l-bottom">
          <div>
            <p class="panel__title">
              Metadata
            </p>
            <pre class="pannel__textarea well well-lg">{{ metadata }}</pre>
          </div>
        </div>
        <div class="modal-footer">
          <button
            v-if="selectedBill.can_charge && selectedBill.has_payments"
            v-permissions:bill.process_payments
            class="btn btn-primary"
            @click="$emit('open-make-bill-paid-modal')"
          >
            Marcar como paga
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import DropdownFilterList from 'components/DropdownFilterList';
import Permissions from 'mixins/Permissions';

export default {
  mixins: [Permissions],
  data() {
    return {
      discountsFilter: [
        { value: true, text: 'Ativos' },
        { value: false, text: 'Desativados' },
      ],
      selectedDiscountsFilter: [true],
    };
  },

  components: {
    DropdownFilterList,
  },

  computed: {
    ...mapState([
      'selectedBill',
      'userPermissions',
    ]),
    metadata() {
      return JSON.stringify(this.selectedBill.metadata, null, 2);
    },

    hasParcelamento() {
      return this.selectedBill.discounts.some(discount => discount.kind === 'parcelamento');
    },
  },

  methods: {
    ...mapMutations([
      'setSelectedDiscount',
    ]),

    discountsFilterChanged(items) {
      this.selectedDiscountsFilter = items;
    },

    filtredDiscounts() {
      return this.selectedBill.discounts.filter(discount => this.selectedDiscountsFilter.includes(discount.enabled));
    },

    openCreateDiscountModal() {
      this.setSelectedDiscount({ bill_id: this.selectedBill.id });
      this.$emit('open-discount-modal');
    },

    openEditDiscountModal(discount) {
      this.setSelectedDiscount(discount);
      this.$emit('open-discount-modal');
    },

    openDisableDiscountModal(discount) {
      this.setSelectedDiscount(Object.assign(discount, { disable: true }));
      this.$emit('open-discount-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
.observations-column {
  max-width: 300px;
}

.discounts-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
}

.discounts-line:not(:first-child) {
  margin-top: 4px;
}

.discounts-button {
  display: flex;
}

.discounts-button>button {
  margin-left: 4px;
}

.total-value {
  color: #0FA866;
  font-size: 18px;
  font-weight: bold;
}
</style>
